












































import Vue from 'vue'
import Modal from '@/components/Modal'
import roleNames from '@/roleNames'
import { Select, Option } from 'element-ui'
import { required, email } from 'vuelidate/lib/validators'
import './InviteTeamMember.scss'
import { KeyDict } from '@/types'
import { Feature } from '@/featureFlags/featureFlags'

export default Vue.extend({
  name: 'InviteTeamMember',
  computed: {
    modalButton (): string {
      return 'Submit'
    },
    roleNamesOptions (): KeyDict<string> {
      return roleNames()
    },
    isSelfServe (): boolean {
      return this.$hasFeature(Feature.SELF_SERVE)
    },
  },
  data: () => ({
    submitStatus: '',
    mode: 'create',
    member: {
      email: '',
      role: '',
      signup_complete: false,
      email_sent: false
    }
  }),
  validations: {
    member: {
      email: {
        required,
        email
      },
      role: {
        required
      }
    }
  },
  methods: {
    formSubmitted () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
      } else {
        if (this.mode === 'create') {
          this.$emit('inviteMember', this.member)
          this.member.email = ''
          this.member.role = ''
          this.hideModal()
        }
      }
    },
    hideModal () {
      this.$emit('closeModal')
    }
  },
  components: {
    Modal,
    'el-select': Select,
    'el-option': Option
  }
})
